module.exports = __webpack_public_path__ + "static/contact-47ae869dfed683cfe8b57bd36ff924ee.jpg";